module.exports = __webpack_public_path__ + "static/media/finalizar.e5f6f6a5.jpg";